import React, { useEffect, useRef } from 'react'
import './middle-section.scss'
import Button from '../../atoms/button/button'
import { navigate } from 'gatsby'
import SectionTitleDivisor from '../../atoms/section-title-divisor/section-title-divisor'
import { StaticImage } from 'gatsby-plugin-image'
import { LOCALE_AT } from '@/constants/activity-constants'
import { WORDS } from '@/constants/keywords'

function Step3CO() {
  return (
    <StaticImage
      height={236}
      src="../../../assets/images/steps/step3.png"
      alt="paso 3 ¡Producto terminado exitosamente! "
      title="¡Producto terminado! "
      placeholder="blurred"
    />
  )
}

function Step3PE() {
  return (
    <StaticImage
      height={236}
      src="../../../assets/images/steps/step3-pe.png"
      alt="paso 3 ¡Producto terminado exitosamente! "
      title="¡Producto terminado! "
      placeholder="blurred"
    />
  )
}
function Step3AR() {
  return (
    <StaticImage
      height={236}
      src="../../../assets/images/steps/step3-ar.png"
      alt="paso 3 ¡Producto terminado exitosamente! "
      title="¡Producto terminado! "
      placeholder="blurred"
    />
  )
}
function Step3CL() {
  return (
    <StaticImage
      height={236}
      src="../../../assets/images/steps/step3-cl.png"
      alt="paso 3 ¡Producto terminado exitosamente! "
      title="¡Producto terminado! "
      placeholder="blurred"
    />
  )
}
function Step3() {
  if (LOCALE_AT.PERU) {
    return <Step3PE />
  }
  if (LOCALE_AT.ARGENTINA) {
    return <Step3AR />
  }
  if (LOCALE_AT.CHILE) {
    return <Step3CL />
  }
  return <Step3CO />
}

function MediaContent() {
  const refScroller = useRef(null)
  const handleNav = (vel: number = 1) => {
    if (!refScroller.current) {
      return
    }
    let element = refScroller.current as HTMLElement
    let dist = window.innerWidth * vel
    element.scrollLeft += dist
  }

  useEffect(() => {
    if (!refScroller.current) {
      return
    }
    let element = refScroller.current as HTMLElement
    const updateNavOnScroll = () => {
      const navPrev = element.querySelector('.nav.--prev')
      const navNext = element.querySelector('.nav.--next')
      const min = window.innerWidth
      const max = element.scrollWidth - window.innerWidth
      navPrev?.classList.remove('disabled')
      navNext?.classList.remove('disabled')
      setTimeout(() => {
        // wait here cuz scroll smooth
        if (element.scrollLeft >= max) {
          navNext?.classList.add('disabled')
        }
        if (element.scrollLeft <= min) {
          navPrev?.classList.add('disabled')
        }
      }, 300)
    }

    element.addEventListener('scroll', updateNavOnScroll)
    return () => {
      element.removeEventListener('scroll', updateNavOnScroll)
    }
  }, [refScroller.current])
  return (
    <article className="media-content " ref={refScroller}>
      <div className="flex wrapper">
        <div
          className="nav --prev"
          onClick={() => handleNav(-1)}
          role="button"
        ></div>
        <div className="nav --next" onClick={() => handleNav(1)}></div>
        <figure>
          <div className="img-wrapper">
            <StaticImage
              src="../../../assets/images/steps/step1.png"
              alt="paso 1 Personaliza tu V-BOT"
              title="Personaliza tu V-BOT"
              placeholder="blurred"
            />
          </div>
          <figcaption>
            {WORDS.Elige} tu V-Bot favorita y el laboratorio que más te guste.
          </figcaption>
        </figure>
        <figure>
          <div className="img-wrapper">
            <StaticImage
              src="../../../assets/images/steps/step2.png"
              alt="paso 2 ayuda a V-BOT a Memorizar la formula "
              title="Memoriza la formula"
              placeholder="blurred"
            />
          </div>
          <figcaption>
            {WORDS.Memoriza} la fórmula de cada producto y {WORDS.selecciona}{' '}
            sus componentes.
          </figcaption>
        </figure>
        <figure>
          <div className="img-wrapper">
            <Step3 />
          </div>
          <figcaption>
            {WORDS.Crea} los productos en los 3 niveles que debes superar, ¡sé
            la mejor!
          </figcaption>
        </figure>
      </div>
    </article>
  )
}
export default function MiddleSection({ id = '' }) {
  return (
    <section
      id={id}
      className="f-middle-section"
      aria-label="descripcion del juego que se va a jugar"
    >
      <SectionTitleDivisor>TU MISIÓN</SectionTitleDivisor>
      <div className="f-middle-section__wrapper">
        <article className="header">
          <h3 className="title" role="heading">
            ¡{WORDS.Ayuda} a V-Bot!
          </h3>
          <p>
            Todos se fueron de vacaciones en el laboratorio Nosotras y V-Bot
            necesita de tu ayuda para crear nuestros productos. {WORDS.Pon} a
            prueba tu memoria,
            <br /> <b>¡{WORDS.demuestra} que eres la mejor!</b>
          </p>
          <p>
            <b>{WORDS.Sigue} estos pasos:</b>
          </p>
        </article>
        <MediaContent />
        <footer>
          <Button
            title="jugemos"
            onClick={() => {
              navigate('/play')
            }}
            data={{ 'data-tag': '7A' }}
          >
            ¡Quiero jugar ya!
          </Button>
        </footer>
      </div>
    </section>
  )
}
